module.exports = __webpack_public_path__ + "img/lucky-draw-bg.ff9c8ba5.png";